function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "how-to-b",
  width: 48,
  height: 48,
  y: .27
}), React.createElement("filter", {
  id: "how-to-a",
  width: "141.7%",
  height: "141.7%",
  x: "-20.8%",
  y: "-16.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "shadowInner"
}), React.createElement("feOffset", {
  dy: 2,
  in: "shadowInner",
  result: "shadowInner"
}), React.createElement("feComposite", {
  in: "shadowOffsetOuter1",
  in2: "shadowInner",
  operator: "out",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})), React.createElement("path", {
  id: "how-to-d",
  d: "M23.736,13 C28.632,13 31.928,15.56 31.928,19.528 C31.928,23.88 26.456,25.16 26.456,26.856 L26.456,27.528 L20.984,27.528 L20.984,25.928 C20.984,23.592 25.144,22.248 25.144,19.656 C25.144,18.472 24.376,17.416 23.032,17.416 C21.304,17.416 20.952,18.76 20.952,20.104 C20.952,20.392 20.952,20.68 20.984,20.968 L15.096,20.968 C15.064,20.552 15,20.168 15,19.752 C15,15.592 18.712,13 23.736,13 Z M26.936,35.4 L20.6,35.4 L20.6,29.48 L26.936,29.48 L26.936,35.4 Z"
}), React.createElement("filter", {
  id: "how-to-c",
  width: "218.1%",
  height: "189.3%",
  x: "-59.1%",
  y: "-35.7%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.0352941176   0 0 0 0 0.0588235294   0 0 0 0 0.0980392157  0 0 0 0.4 0"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#how-to-a)",
  xlinkHref: "#how-to-b"
}), React.createElement("rect", {
  width: 44,
  height: 44,
  x: 2,
  y: 2.27,
  stroke: "#FFF",
  strokeLinejoin: "square",
  strokeWidth: 4
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#how-to-c)",
  xlinkHref: "#how-to-d"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#how-to-d"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/howTo.8d6c9c04.svg";
export { SvgComponent as ReactComponent };